import React, { useEffect } from 'react';

const CodeBox = ({ code, auto }) => {

    // {/* x---------------------------------x Form Layouts Code Section x---------------------------------x */}
    useEffect(() => {
        const loadPrettify = () => {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/gh/google/code-prettify@master/loader/prettify.js';
            script.defer = true;

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = 'https://cdn.jsdelivr.net/gh/google/code-prettify@master/loader/prettify.css';

            // Append script and link
            document.body.appendChild(script);
            document.head.appendChild(link);

            script.onload = () => {
                if (window.PR) {
                    window.PR.prettyPrint();
                }
            };

            return () => {
                document.body.removeChild(script);
                document.head.removeChild(link);
            };
        };
        const cleanup = loadPrettify();

        return cleanup;
    }, []);

    return (
        // {/* x---------------------------------x Code Box All Section x---------------------------------x */}
        <pre
            className='h6 language-html overflow-y-scroll custom_scroll mt-2 prettyprint rounded-lg bg-black bg-opacity-10 text-start'
            style={{
                height: auto ? "auto" : "450px",
                width: "100%"
            }}>
            <code className="language-sh text-center overflow-x-scroll p-2" data-lang="sh">
                {/* // x---------------------------------x Code Section As Props x---------------------------------x */}
                {code}
            </code>
        </pre>
    );
};

export default CodeBox;
